import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import Ad from '@ifeng-fe/ui_pc_ad';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import TopicSlide from './topicSlide';
import TopicReview from './topicReview';
import TopicTitle from '../../components/topicTitle';
import Recommend from './recommend';
import PointView from './pointView';
import TopicComment from './topicComment';
import { getCommentCounts } from '@ifeng-fe/container_content/common/client/services/api';
import { Quan } from './quan/quan';
import TimelineH5 from './timeline/timeline';
let firstFlowId = '';

class Modules extends React.PureComponent {
    static propTypes = {
        docData: PropTypes.object,
        content: PropTypes.array,
        ad: PropTypes.object,
    };

    state = {
        count: [],
        newCount: {},
    };

    async componentDidMount() {
        const {
            docData: { dataVersion },
            content,
        } = this.props;

        const countArr = [];
        const newCount = {};

        if (dataVersion && dataVersion === 'v2') {
            const columnData = [
                ...content.filter(
                    item =>
                        item.type === 'flow' &&
                        item.display === 1 &&
                        item.data.articleList &&
                        item.data.articleList.length > 0,
                ),
            ];

            for (let i = 0; i < columnData.length; i++) {
                if (i === 0) {
                    firstFlowId = columnData[i].id;
                }

                const urlArr = columnData[i].data.articleList.map(item => item.commentUrl || item.id);
                const count = await getCommentCounts(urlArr);

                newCount[columnData[i].id] = count;
            }
        } else {
            let columnData = [
                ...content.filter(item => item.type === 'column' && item.display === 1 && item.data.length > 0),
            ];

            columnData = columnData.length > 0 ? columnData[0] : { data: [] };

            for (let i = 0; i < columnData.data.length; i++) {
                const urlArr = columnData.data[i].articleList.map(item => item.commentUrl || item.id);
                const count = await getCommentCounts(urlArr);

                countArr.push(count);
            }
        }

        this.setState({
            count: [...countArr],
            newCount: { ...newCount },
        });
    }

    getRecommend = (index, data, infoAd) => {
        const { count } = this.state;

        return index === 0 ? (
            <Recommend data={data} count={count[index] || []} infoAd={infoAd} />
        ) : (
            <Recommend data={data} count={count[index] || []} />
        );
    };

    getFlow = (id, data, infoAd) => {
        const { newCount } = this.state;

        return firstFlowId === id ? (
            <Recommend data={data} count={newCount[id] || []} infoAd={infoAd} />
        ) : (
            <Recommend data={data} count={newCount[id] || []} />
        );
    };

    getModule(content) {
        const {
            docData: { title, slideDisplay, commentUrl, skey, pcUrl },
            ad: { slideAd, infoAd, titleAd1, titleAd2, titleAd3, titleAd4, columnAd1, columnAd2, columnAd3 },
        } = this.props;

        const titleAdArr = [titleAd1, titleAd2, titleAd3, titleAd4];
        const columnAdArr = [columnAd1, columnAd2, columnAd3];

        return content.map(item => {
            const titleAd = titleAdArr[item.moduleIndex - 1];
            const columnAd = columnAdArr[item.moduleIndex - 1];

            if (item.type === 'slide' && slideDisplay === 1 && item.data.length > 0) {
                return <TopicSlide key={item.id} content={item} slideAd={slideAd} />;
            }

            if (item.type === 'review' && item.display === 1 && item.data.length > 0) {
                return (
                    <React.Fragment key={item.id}>
                        <TopicReview content={item} titleAd={titleAd} />
                        <NoSSR>{columnAd ? <Ad content={columnAd} styleName={styles.column_box} /> : ''}</NoSSR>
                    </React.Fragment>
                );
            }
            if (item.type === 'timeline') {
                return <TimelineH5 key={item.id} content={item} />;
            }
            if (item.type === 'discuss' && item.display === 1) {
                return <Quan content={item} />;
            }
            if (item.type === 'column' && item.display === 1 && item.data.length > 0) {
                return (
                    <div className={styles.topic_column} key={item.id}>
                        {item.data.map((col, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <TopicTitle
                                        id={item.specialId}
                                        moduleIndex={col.moduleIndex}
                                        title={col.columnName}
                                        titleAd={titleAdArr[col.moduleIndex - 1]}
                                    />
                                    {this.getRecommend(index, col.articleList, infoAd)}
                                    <NoSSR>
                                        {columnAdArr[col.moduleIndex - 1] ? (
                                            <Ad
                                                content={columnAdArr[col.moduleIndex - 1]}
                                                styleName={styles.column_box}
                                            />
                                        ) : (
                                            ''
                                        )}
                                    </NoSSR>
                                </React.Fragment>
                            );
                        })}
                    </div>
                );
            }

            if (
                item.type === 'flow' &&
                item.display === 1 &&
                item.data.articleList &&
                item.data.articleList.length > 0
            ) {
                return (
                    <div className={styles.topic_column} key={item.id}>
                        <TopicTitle
                            id={item.specialId}
                            moduleIndex={item.moduleIndex}
                            title={item.title}
                            titleAd={titleAdArr[item.moduleIndex - 1]}
                        />
                        {this.getFlow(item.id, item.data.articleList, infoAd)}
                        <NoSSR>
                            {columnAdArr[item.moduleIndex - 1] ? (
                                <Ad content={columnAdArr[item.moduleIndex - 1]} styleName={styles.column_box} />
                            ) : (
                                ''
                            )}
                        </NoSSR>
                    </div>
                );
            }

            if (item.type === 'point' && item.display === 1 && item.data.length > 0) {
                return (
                    <React.Fragment key={item.id}>
                        <PointView content={item} titleAd={titleAd} />
                        <NoSSR>{columnAd ? <Ad content={columnAd} styleName={styles.column_box} /> : ''}</NoSSR>
                    </React.Fragment>
                );
            }

            if (item.type === 'comment' && item.display === 1 && item.data[0] && item.data[0].allowComment !== -1) {
                return (
                    <React.Fragment key={item.id}>
                        <TopicComment
                            content={item}
                            docTitle={title}
                            commentUrl={commentUrl}
                            pcUrl={pcUrl}
                            skey={skey}
                            titleAd={titleAd}
                        />
                        <NoSSR>{columnAd ? <Ad content={columnAd} styleName={styles.column_box} /> : ''}</NoSSR>
                    </React.Fragment>
                );
            }

            return '';
        });
    }

    render() {
        const { content } = this.props;

        return <div className={styles.modules}>{this.getModule(content)}</div>;
    }
}

export default errorBoundary(Modules);
